import React, { Fragment, useContext } from 'react';
import useGridListStyles from './styles';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

const TextGrid = ({ sectionData }) => {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);
  const [nodeData] = sectionData.components;
  const cardsCount = nodeData?.contentList?.components?.length;
  const slidesToShow = isMobile ? 1 : 2;
  const classes = useGridListStyles({
    containerWidth,
    cardsCount,
    slidesToShow,
    isMobile
  });

  const settings = {
    className: classes.sliderContainer,
    infinite: false,
    slidesToShow: isMobile ? 1.1 : 2
  };

  const carouselContent = nodeData?.contentList?.components?.map(
    (item, index) => (
      <Fragment key={index}>
        <div className={classes.node}>
          <h3
            ref={item?.contentHeading?.refSetter}
            className={classes.nodeTitle}
            dangerouslySetInnerHTML={{
              __html: item.contentHeading.metadata.value
            }}
          />
          <p
            ref={item?.contentPara?.refSetter}
            className={classes.nodePara}
            dangerouslySetInnerHTML={{
              __html: item.contentPara.metadata.value
            }}
          />
        </div>
      </Fragment>
    )
  );

  return (
    <section className={classes.section}>
      <div className={classes.sectionContainer}>
        <div className={classes.subheading}>
          <span
            ref={nodeData?.subheading?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.subheading.metadata.value
            }}
          />
        </div>
        <h2 className={classes.heading}>
          <span
            ref={nodeData?.title?.refSetter}
            dangerouslySetInnerHTML={{
              __html: nodeData.title.metadata.value
            }}
          />
        </h2>
        <div className={classes.slickContainer}>
          {cardsCount > slidesToShow ? (
            <Carousel hideArrow={isMobile} settings={settings}>
              {carouselContent}
            </Carousel>
          ) : (
            <div className={classes.contentRow}>{carouselContent}</div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TextGrid;
